export const GET_GCP_THRESHOLD_SUCCESS = "GET_GCP_THRESHOLD_SUCCESS";
export const GET_GCP_THRESHOLD_FAIL = "GET_GCP_THRESHOLD_FAIL";
export const GET_GCP_THRESHOLD = "GET_GCP_THRESHOLD";
export const PUT_GCP_THRESHOLD = "PUT_GCP_THRESHOLD";
export const PUT_GCP_THRESHOLD_SUCCESS = "PUT_GCP_THRESHOLD_SUCCESS";
export const PUT_GCP_THRESHOLD_FAIL = "PUT_GCP_THRESHOLD_FAIL";
export const POST_DISABLE_GCP_THRESHOLD_ALERTS = "POST_DISABLE_GCP_THRESHOLD_ALERTS";
export const POST_DISABLE_GCP_THRESHOLD_ALERTS_FAIL = "POST_DISABLE_GCP_THRESHOLD_ALERTS_FAIL";
export const POST_ENABLE_GCP_THRESHOLD_ALERTS = "POST_ENABLE_GCP_THRESHOLD_ALERTS";
export const POST_ENABLE_GCP_THRESHOLD_ALERTS_FAIL = "POST_ENABLE_GCP_THRESHOLD_ALERTS_FAIL";
export const POST_DISABLE_GCP_THRESHOLD_ALERTS_SUCCESS = "POST_DISABLE_GCP_THRESHOLD_ALERTS_SUCCESS";
export const POST_ENABLE_GCP_THRESHOLD_ALERTS_SUCCESS = "POST_ENABLE_GCP_THRESHOLD_ALERTS_SUCCESS";